export default {
    slug: 'bo/option-links',
    title: 'Option Links',
    visible: [
        'option.label'
    ],
    listview: 'OptionLinkssListView',
    locales: ['common'],
    columns: [
        {
            key: 'label',
            label: 'Label',
            main: true,
        }
    ],
    actions: {

    },
    copyColumns: [
        'uuid'
    ],
    tooltipColumns: [
        'uuid'
    ]
}



// WEBPACK FOOTER //
// ./src/app/store/bookable-objects/option-links/state.js